import { render, staticRenderFns } from "./suggested_coins.vue?vue&type=template&id=462d7b95&"
import script from "./suggested_coins.vue?vue&type=script&lang=js&"
export * from "./suggested_coins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports